import React from "react";
import "./Markers.scss";
import GreenPinIcon from "../../../GreenPinIcon";
import RedPinIcon from "../../../redPin";

export const Markers = ({ count, type, onOpenStateChanged }) => {
  return (
    <div
      style={{
        position: "absolute",
        transform: "translate(-50%, -100%)",
        color: "black",
        textAlign: "center",
        width: "120px",
        cursor: "pointer",
      }}
      onClick={() => onOpenStateChanged?.()}
    >
      {count != 1 ? (
        <button className={`markersButton ${"green-pin"}`}>{count}</button>
      ) : count == 1 && type == "vattenfall" ? (
        <>
          <RedPinIcon />
        </>
      ) : (
        <>
          <GreenPinIcon />
        </>
      )}
    </div>
  );
};
